import { getApiStatus } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

const useApiStatus = () => {
  const { data, error } = useQuery<boolean>({
    queryKey: ['HEALTH_CHECK'],
    queryFn: () => getApiStatus(),
  })
  return { isHealthy: !!data && !error }
}

export default useApiStatus
